import { useModuleBEM } from "@b2bportal/core-themes";
import { Breadcrumbs } from "@tenant/ui";
import clsx from "clsx";
import { usePackageBreadcrumbs } from "./hook";
import styles from "./PackageBreadcrumbs.module.scss";
import { useIsUpSell } from "@/overrides/packages/hooks";
import type { CombinedPackageSteps } from "@/pages/Packages";
interface PackageBreadcrumbsComponentProps {
  currentStep: CombinedPackageSteps;
  className?: string;
}

export const PackageBreadcrumbs = ({
  currentStep,
  className,
}: PackageBreadcrumbsComponentProps) => {
  const [block] = useModuleBEM(styles, "PackageBreadcrumbs");
  const { breadcrumbSteps } = usePackageBreadcrumbs(currentStep);
  const isUpSell = useIsUpSell();

  if (isUpSell) {
    return null;
  }

  return (
    <Breadcrumbs steps={breadcrumbSteps} className={clsx(block, className)} />
  );
};
